const NotificationTypes = {

    FETCH_NOTIFICATIONS: {
        SUCCESS: 'FETCH_NOTIFICATIONS_SUCCESS',
        FAILURE: 'FETCH_NOTIFICATIONS_FAILURE',
        PENDING: 'FETCH_NOTIFICATIONS_PENDING',
    },

}

export default NotificationTypes;